import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

const SearchVendors = () => {
  // Helper to get distance between two zip codes using the vendor API
  async function getZipDistance(zip1, zip2) {
    try {
      //const res = await fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/api/zip-distance?zip1=${zip1}&zip2=${zip2}`);
       const res = await fetch(`https://www.zipcodeapi.com/rest/js-hWih7uMcpWE7C2nD3vdIzDTy38wuILRFBwy4rs2vzyntwD21DIQSHRc4czsKkjaM/distance.json/${zip1}/${zip2}/mile`);
      const data = await res.json();
      return data.distance || 0;
    } catch {
      return 0;
    }
  }
 
  const { productId } = useParams();
  const location = useLocation();
  const [date, setDate] = useState('');
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [vendorRatings, setVendorRatings] = useState({});
  const navigate = useNavigate();

  // Fill fields from URL query params
  useEffect(() => {
    // Fetch ratings for all vendors after vendors are loaded
   

    const params = new URLSearchParams(location.search);
    const urlDate = params.get('date');
    const urlStartTime = params.get('startTime');
    const urlEndTime = params.get('endTime');
    if (urlDate) setDate(urlDate);
    if (urlStartTime) setStartTime(urlStartTime);
    if (urlEndTime) setEndTime(urlEndTime);
  }, [location.search]);

  // Run search_vendors API when page loads and when relevant fields change
  useEffect(() => {
    if (!date || !startTime || !endTime) return;

    const fetchVendors = async () => {
      setLoading(true);
      const dayOfWeek = new Date(date + 'T00:00:00').toLocaleDateString('en-US', { weekday: 'long' })
      try {
        const res = await axios.get(`${process.env.REACT_APP_VENDOR_DOMAIN}/api/search_vendors`, {
          params: {
            productId,
            dayOfWeek,
            startTime,
            endTime,
            date
          }
        });


  


        // Get user zip code
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        const userZip = user.zipcode;
        // Filter vendors by zip code distance
        const filteredVendors = [];
        for (const vendor of res.data) {
          if (vendor.zipcode && userZip) {
            const distance = await getZipDistance(userZip, vendor.zipcode);
            if (distance !== null && distance <= 300) {
              filteredVendors.push(vendor);
            }
          } else {
            // If zip code missing, include vendor by default
            filteredVendors.push(vendor);
          }
        }

  const fetchRatings = async () => {
        const ratingsMap = {};
        
        await Promise.all(
          filteredVendors.map(async (vendor) => {
            try {
              const res = await axios.get(`${process.env.REACT_APP_VENDOR_DOMAIN}/customer_ratings`, {
                params: { vendor_id: vendor.id }
              });
              const ratings = res.data.ratings || [];
              if (ratings.length > 0) {
                const avg = (ratings.reduce((sum, r) => sum + r.rating, 0) / ratings.length).toFixed(2);
                ratingsMap[vendor.id] = { avg, count: ratings.length };
              } else {
                ratingsMap[vendor.id] = { avg: null, count: 0 };
              }
            } catch {
              ratingsMap[vendor.id] = { avg: null, count: 0 };
            }
          })
        );
        setVendorRatings(ratingsMap);
      };
      fetchRatings();



        // Fetch hourly rates for each vendor
        const vendorsWithRates = await Promise.all(
          filteredVendors.map(async (vendor) => {
            try {
              const rateRes = await axios.get(`${process.env.REACT_APP_VENDOR_DOMAIN}/api/vendor_rate`, {
                params: {
                  vendor_id: vendor.id,
                  day_of_month: dayOfWeek,
                  service_detail_id: productId
                }
              });
              return {
                ...vendor,
                hourly_rate: rateRes.data.hourly_rate || 0
              };
            } catch (err) {
              return {
                ...vendor,
                hourly_rate: 0
              };
            }
          })
        );
        setVendors(vendorsWithRates);
      } catch (err) {
        setVendors([]);
      }
      setLoading(false);
    };
    fetchVendors();
  }, [productId, date, startTime, endTime]);

  return (
    <div style={styles.pageBg}>
      <div className="container mt-5">
        <div className="card shadow-lg mx-auto" style={styles.card}>
          <div className="card-body">
            <div className="d-flex align-items-center mb-3">
              <button
                className="btn btn-success"
                style={styles.backBtn}
                onClick={() => navigate(
                  `/serviceappointments/${productId}?date=${date}&startTime=${startTime}&endTime=${endTime}&productDetailId=${productId}`
                )}
              >
                &#8592; Back to Search
              </button>
            </div>
            <hr />
            {loading && (
              <div className="text-center my-3" style={styles.loadingText}>
                Searching...
              </div>
            )}
            {!loading && vendors.length > 0 && (
              <div>
                <h5 className="mb-3 text-success" style={styles.sectionTitle}>
                  Available Coaches:
                </h5>
                {/* Show login/signup prompt if user is not logged in */}
                {!localStorage.getItem('user') && (
                  <div style={{ color: '#d32f2f', fontWeight: 'bold', marginBottom: '18px', textAlign: 'center' }}>
                    Please log in or sign up before you can request vendor services
                  </div>
                )}
                <ul className="list-group">
                  {vendors.map(vendor => (
                    <li
                      key={vendor.id}
                      className="list-group-item"
                      style={styles.vendorCard}
                    >
                      <div style={{ width: '100%' }}>
                        <div style={styles.vendorHeader}>
                          <div style={styles.avatarCircle}>
                            {vendor.firstName?.[0]?.toUpperCase() || '?'}
                          </div>
                          <div>
                            <strong style={styles.vendorName}>
                              {vendor.firstName} {vendor.lastName}
                            </strong>
                            <div style={styles.hourlyRate}>
                              ${vendor.hourly_rate}/hour
                            </div>
                            {/* Customer Ratings */}
                            <div style={{ margin: '6px 0', color: '#8d6e36', fontWeight: 'bold', fontSize: '1.05rem' }}>
                              {vendorRatings[vendor.id]?.avg
                                ? `Customer Ratings: ${'★'.repeat(Math.round(vendorRatings[vendor.id].avg))}${'☆'.repeat(5 - Math.round(vendorRatings[vendor.id].avg))} (${vendorRatings[vendor.id].avg}/5, ${vendorRatings[vendor.id].count} reviews)`
                                : 'No ratings yet'}
                            </div>
                            {vendor.description && (
                              <div style={styles.vendorDesc}>
                                {vendor.description}
                              </div>
                            )}
                          </div>
                        </div>
                        {/* Only show textarea if user is logged in */}
                        {localStorage.getItem('user') && (
                          <textarea
                            maxLength={500}
                            placeholder="Add a message for the coach as to what you are looking for in this session (max 500 characters)"
                            style={styles.messageBox}
                            value={vendor.message || ''}
                            onChange={e => {
                              const msg = e.target.value;
                              setVendors(prev =>
                                prev.map(v =>
                                  v.id === vendor.id ? { ...v, message: msg } : v
                                )
                              );
                            }}
                          />
                        )}
                      </div>
                      <div className="d-flex gap-2" style={styles.actionRow}>
                        {localStorage.getItem('user') ? (
                          <>
                            <button
                              style={styles.requestBtn}
                              onClick={async () => {
                                if (window.confirm(`Are you sure you want to send a request to ${vendor.firstName} ${vendor.lastName}?`)) {
                                  const user = JSON.parse(localStorage.getItem('user') || '{}');
                                  const customer_id = user.id;
                                  const status = 'pending';

                                  // Get start_time, end_time, and date from URL params
                                  const params = new URLSearchParams(location.search);
                                  const start_time = params.get('startTime');
                                  const end_time = params.get('endTime');
                                  const date = params.get('date');
                                  const product_detail_id = productId;
                                  const message = vendor.message || '';

                                  try {
                                    const response = await fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/vendor_appointments`, {
                                      method: 'POST',
                                      headers: { 'Content-Type': 'application/json' },
                                      body: JSON.stringify({
                                        customer_id,
                                        vendor_id: vendor.id || vendor.vendor_id,
                                        status,
                                        start_time,
                                        end_time,
                                        date,
                                        product_detail_id,
                                        hourly_rate: vendor.hourly_rate,
                                        notes: message // Pass textbox value as 'notes'
                                      }),
                                    });
                                    const result = await response.json();
                                    if (result.success) {
                                      
                                      navigate('/customerdashboard'); // Navigate to customer dashboard
                                    } else {
                                      alert(result.message || 'Failed to send request.');
                                    }
                                  } catch {
                                    alert('Error sending request.');
                                  }
                                }
                              }}
                            >
                              Request
                            </button>
                            <button
                              className="btn btn-info btn-sm"
                              style={styles.detailsBtn}
                              onClick={() => navigate(`/vendordetails/${vendor.id}`)}
                            >
                              Details
                            </button>
                          </>
                        ) : null}
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            {!loading && vendors.length === 0 && (
              <div className="text-center text-muted mt-3" style={styles.noVendorsText}>
                No vendors available for selected time.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  pageBg: {
    minHeight: '100vh',
    background: 'linear-gradient(120deg, #f5f6fa 0%, #e3e6f3 100%)',
    paddingBottom: '40px',
  },
  card: {
    maxWidth: 700,
    borderRadius: 20,
    background: '#fff',
  },
  backBtn: {
    fontWeight: 'bold',
    fontSize: '1.08rem',
    borderRadius: '8px',
    boxShadow: '0 1px 4px #c8e6c9',
    marginRight: '18px',
    padding: '8px 18px',
  },
  loadingText: {
    color: '#8d6e36',
    fontWeight: 'bold',
    fontSize: '1.1rem',
  },
  sectionTitle: {
    fontWeight: 'bold',
    fontSize: '1.15rem',
    letterSpacing: '0.5px',
  },
  vendorCard: {
    borderRadius: '14px',
    marginBottom: '18px',
    boxShadow: '0 2px 12px #e0cfa0',
    background: '#f9fafc',
    flexDirection: 'column',
    alignItems: 'stretch',
    padding: '22px 18px',
    display: 'flex',
    gap: '10px',
  },
  vendorHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '18px',
    marginBottom: '8px',
  },
  avatarCircle: {
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    background: '#4078c0',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    fontSize: '1.5rem',
    marginRight: '8px',
    boxShadow: '0 1px 4px #b3c6e6',
  },
  vendorName: {
    color: '#4078c0',
    fontSize: '1.13rem',
    fontWeight: 'bold',
    letterSpacing: '0.5px',
  },
  hourlyRate: {
    color: '#388e3c',
    fontSize: '1.1rem',
    fontWeight: 'bold',
    margin: '4px 0',
    background: '#e8f5e8',
    padding: '4px 8px',
    borderRadius: '6px',
    display: 'inline-block',
  },
  vendorDesc: {
    color: '#555',
    fontSize: '0.98rem',
    margin: '4px 0 10px 0',
    fontStyle: 'italic',
    maxWidth: '420px',
    lineHeight: 1.5,
  },
  messageBox: {
    borderRadius: '8px',
    border: '1px solid #ccc',
    padding: '10px 14px',
    marginTop: '10px',
    marginBottom: '0',
    fontSize: '1rem',
    width: '100%',
    minHeight: '70px',
    maxHeight: '120px',
    resize: 'vertical',
    boxShadow: '0 1px 4px #e0e0e0',
    background: '#fff',
  },
  actionRow: {
    marginTop: '14px',
    justifyContent: 'flex-end',
    display: 'flex',
    gap: '10px',
  },
  requestBtn: {
    backgroundColor: '#4078c0',
    color: '#fff',
    fontWeight: 'bold',
    borderRadius: '6px',
    padding: '8px 18px',
    border: 'none',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
    boxShadow: '0 1px 4px #b3c6e6',
    fontSize: '1rem',
  },
  detailsBtn: {
    fontWeight: 'bold',
    borderRadius: '6px',
    boxShadow: '0 1px 4px #b3c6e6',
    fontSize: '1rem',
    padding: '8px 18px',
  },
  noVendorsText: {
    fontWeight: 'bold',
    fontSize: '1.08rem',
    color: '#b0a16b',
    marginTop: '32px',
    fontStyle: 'italic',
  },
};

export default SearchVendors;